/**
 * Miradi Share UX Services
 * Miradi Share UX Services end-point (for internal use only)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProgressReportStatusEnum } from './progressReportStatusEnum';


/**
 * Count of progress reports by Status
 */
import { ValidateUtils } from 'app/shared/utils';

export class ProgressStatusCount { 
    /**
     * Status count
     */
    readonly count?: number;
    status?: ProgressReportStatusEnum;

    constructor(item?: Partial<ProgressStatusCount>) {
        
        Object.assign(this, item);
    }

    static getValidationObject(): any {
        return {
            count: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.count : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            status: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.status : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            isValid: ProgressStatusCount.isValid,
        };
    }

    static isValid(obj: ProgressStatusCount): boolean {
        if (!!obj) {
            const item = obj as any; // just to make things easier in this generated code...
            const validationObject = ProgressStatusCount.getValidationObject();
            let result = !item.$validationMessage;
            result = result && validationObject.count.isValid(item);
            result = result && validationObject.status.isValid(item);
            return result;
        } else {
            return false
        }
    }
}

